import * as Toastr from "toastr";

export class ShippingErrorHandler {
    static handleApiError(error: any, defaultMessage: string): string {
        let errorMessage = defaultMessage;
        
        if (error && error.responseJSON && error.responseJSON.message) {
            errorMessage = error.responseJSON.message;
        }
        
        return errorMessage;
    }

    static showError(message: string, timeout: number = 5000): void {
        Toastr.error(message, {
            timeOut: timeout,
            positionClass: 'toast-top-right'
        });
    }

    static showWarning(message: string, timeout: number = 3000): void {
        Toastr.warning(message, {
            timeOut: timeout,
            positionClass: 'toast-top-right'
        });
    }

    static showSuccess(message: string, timeout: number = 3000): void {
        Toastr.success(message, {
            timeOut: timeout,
            positionClass: 'toast-top-right'
        });
    }

    static logError(context: string, error: any): void {
        console.error(`Error in ${context}:`, error);
    }
}

